<template>
  <div class="header-pc">
    <img
      src="@/assets/geeksalon.png"
      height="24px"
      class="logo"
      @click="toHome"
    />
  </div>
</template>

<script>
export default {
  name: "PcHeader",
  methods: {
    toHome() {
      this.$router.push("/")
    },
  },
}
</script>

<style lang="scss">
.header-pc {
  position: relative;
  background: transparent url("./images/minproheader3.png") 0% 0% no-repeat
    padding-box;
  background-size: cover;
  padding-top: 18%;

  @font-face {
    font-family: "GenJyuuGothic";
    src: url("./fonts/GenJyuuGothicX.woff");
  }

  .logo {
    position: absolute;
    top: 0;
    overflow: hidden;
    margin: 40px 0 0 80px;
    cursor: pointer;
  }
}
</style>
